import React, {useEffect} from "react";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import useSeller from "./useSeller";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";

export default function () {
  const {handleSubmit, setErrors, sellerFields, reset} = useSeller();
  const navigate = useNavigate();
  const {id} = useParams();

  useEffect(() => {
    axios.get(`sellers/${id}/edit`).then(res => {
      reset(res.data.seller);
    });
  }, []);

  const editSeller = data => {
    axios.put(`sellers/${id}`, data).then(res => {
      navigate('/sellers');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data?.errors || {});
      }
    });
  }

  return (
    <Card title="Edit">
      <form className="form w-100" onSubmit={handleSubmit(editSeller)}>
        {sellerFields}

        <SubmitButton title="Update" classes='mt-5'/>
      </form>
    </Card>
  );
}